module.exports = __webpack_public_path__ + "static/img/game-img1.4b184bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game-img1.png
// module id = y0AU
// module chunks = 1